import React, { useState } from 'react';

export default function Card({ type, block, time, del }) {
    const [showModal, setShowModal] = useState(false);

    const getNetworkColor = (network) => {
        const colors = {
            optimism: "bg-[#FF0420]",
            solana: "bg-[#1f1f1f]",
            base: "bg-[#0051ff]",
            arbitrum: "bg-[#213147]",
            polygon: "bg-[#6a00f5]",
            binance: "bg-[#f3bc30]",
        }
        return colors[network] || "bg-black"
    };

    const getNetworkSvg = (network) => {
        const colors = {
            solana: (<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08398 5.22265C7.17671 5.08355 7.33282 5 7.5 5H18.5C18.6844 5 18.8538 5.10149 18.9408 5.26407C19.0278 5.42665 19.0183 5.62392 18.916 5.77735L16.916 8.77735C16.8233 8.91645 16.6672 9 16.5 9H5.5C5.3156 9 5.14617 8.89851 5.05916 8.73593C4.97215 8.57335 4.98169 8.37608 5.08398 8.22265L7.08398 5.22265ZM7.76759 6L6.43426 8H16.2324L17.5657 6H7.76759Z" fill="#ffffff" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08398 15.2226C7.17671 15.0836 7.33282 15 7.5 15H18.5C18.6844 15 18.8538 15.1015 18.9408 15.2641C19.0278 15.4267 19.0183 15.6239 18.916 15.7774L16.916 18.7774C16.8233 18.9164 16.6672 19 16.5 19H5.5C5.3156 19 5.14617 18.8985 5.05916 18.7359C4.97215 18.5734 4.98169 18.3761 5.08398 18.2226L7.08398 15.2226ZM7.76759 16L6.43426 18H16.2324L17.5657 16H7.76759Z" fill="#ffffff" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08398 13.7774C7.17671 13.9164 7.33282 14 7.5 14H18.5C18.6844 14 18.8538 13.8985 18.9408 13.7359C19.0278 13.5733 19.0183 13.3761 18.916 13.2226L16.916 10.2226C16.8233 10.0836 16.6672 10 16.5 10H5.5C5.3156 10 5.14617 10.1015 5.05916 10.2641C4.97215 10.4267 4.98169 10.6239 5.08398 10.7774L7.08398 13.7774ZM7.76759 13L6.43426 11H16.2324L17.5657 13H7.76759Z" fill="#ffffff" />
            </svg>),
            optimism: (<svg width="20px" height="20px" viewBox="0 0 28 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4695 14.6399C14.3165 14.6399 14.2145 14.589 14.1635 14.4869C14.0615 14.3849 14.0615 14.2829 14.0615 14.1299L16.7135 1.53295C16.7645 1.37995 16.8155 1.27795 16.9175 1.17595C17.0195 1.07395 17.1725 1.02295 17.2745 1.02295H22.4255C23.1905 1.02295 23.9045 1.12495 24.5675 1.27795C25.2305 1.48195 25.7405 1.73695 26.1995 2.09395C26.6075 2.45095 26.9135 2.96095 27.0665 3.52195C27.2195 4.08295 27.2195 4.74595 27.0665 5.45995C26.7605 6.93895 26.0975 8.06095 25.0775 8.77495C24.1085 9.48895 22.7825 9.84595 21.0995 9.84595H18.4985L17.6315 14.0789C17.5805 14.2319 17.5295 14.3339 17.4275 14.4359C17.3255 14.5379 17.2235 14.589 17.0705 14.589H14.4695V14.6399ZM19.0595 7.24495H21.3035C21.8135 7.24495 22.3235 7.09195 22.7315 6.83695C23.1395 6.53095 23.4455 6.12295 23.5475 5.56195C23.5985 5.20495 23.6495 4.94995 23.5985 4.69495C23.5475 4.43995 23.4455 4.23595 23.1905 4.08295C22.9865 3.92995 22.6295 3.82795 22.1705 3.82795H19.8245L19.0595 7.24495Z" fill="white" />
                <path d="M6.15647 14.8439C5.34047 14.8439 4.57548 14.7419 3.91248 14.5379C3.19848 14.3339 2.63748 13.9769 2.12748 13.5689C1.66848 13.1099 1.31148 12.5999 1.10748 11.9369C0.903476 11.2739 0.903476 10.5089 1.00548 9.6419C1.10748 9.0809 1.20948 8.5199 1.31148 7.9589C1.46448 7.3979 1.56648 6.8369 1.71948 6.2759C2.12748 4.5419 2.89248 3.2159 4.01448 2.2979C5.13648 1.3799 6.61548 0.920898 8.50248 0.920898C9.31848 0.920898 10.0835 1.0229 10.7465 1.2779C11.4605 1.4819 12.0215 1.8389 12.5315 2.2979C13.0415 2.7569 13.3475 3.3179 13.5515 3.9809C13.7555 4.6439 13.8065 5.4089 13.6535 6.2759C13.5515 6.8369 13.4495 7.3979 13.3475 7.9589C13.2455 8.4689 13.0925 9.0299 12.9905 9.5399C12.5315 11.3249 11.7665 12.6509 10.6445 13.5179C9.52248 14.3849 8.04347 14.8439 6.15647 14.8439ZM6.41147 12.0389C7.12547 12.0389 7.73748 11.8349 8.24748 11.4269C8.75748 11.0189 9.16548 10.3559 9.36948 9.4379C9.52248 8.8769 9.62447 8.3159 9.72647 7.8059C9.82847 7.2959 9.93048 6.7859 10.0325 6.2249C10.1855 5.3069 10.1345 4.6439 9.77748 4.2359C9.47148 3.8279 8.96148 3.6239 8.24748 3.6239C7.53348 3.6239 6.92147 3.8279 6.41147 4.2359C5.90147 4.6439 5.54448 5.3069 5.28948 6.2249C5.13648 6.7859 5.03447 7.2959 4.88147 7.8059C4.77947 8.3159 4.67748 8.8259 4.57548 9.4379C4.42248 10.3559 4.47348 11.0189 4.83048 11.4269C5.18748 11.8349 5.69747 12.0389 6.41147 12.0389Z" fill="white" />
            </svg>),
            base: (<svg width="20px" height="20px" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_354_1442)"><path d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z" fill="white" /><path d="M10.5462 17.7966C14.6159 17.7966 17.9149 14.5032 17.9149 10.4406C17.9149 6.37808 14.6159 3.08472 10.5462 3.08472C6.68517 3.08472 3.51771 6.0491 3.20312 9.82232H12.9429V11.059H3.20312C3.51771 14.8322 6.68517 17.7966 10.5462 17.7966Z" fill="#0052FF" /></g><defs><clipPath id="clip0_354_1442"><rect width="21" height="21" fill="white" /></clipPath></defs></svg>),
            arbitrum: (<svg width="20px" height="20px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 2500 2500"
                fill="none"
            >
                <rect width="2500" height="2500" fill="none" />
                <path
                    fill="#213147"
                    d="M226,760v980c0,63,33,120,88,152l849,490c54,31,121,31,175,0l849-490c54-31,88-89,88-152V760
      c0-63-33-120-88-152l-849-490c-54-31-121-31-175,0L314,608c-54,31-87,89-87,152H226z"
                />
                <path
                    fill="#12AAFF"
                    d="M1435,1440l-121,332c-3,9-3,19,0,29l208,571l241-139l-289-793C1467,1422,1442,1422,1435,1440z"
                />
                <path
                    fill="#12AAFF"
                    d="M1678,882c-7-18-32-18-39,0l-121,332c-3,9-3,19,0,29l341,935l241-139L1678,883V882z"
                />
                <path
                    fill="#9DCCED"
                    d="M1250,155c6,0,12,2,17,5l918,530c11,6,17,18,17,30v1060c0,12-7,24-17,30l-918,530c-5,3-11,5-17,5
      s-12-2-17-5l-918-530c-11-6-17-18-17-30V719c0-12,7-24,17-30l918-530c5-3,11-5,17-5l0,0V155z M1250,0c-33,0-65,8-95,25L237,555
      c-59,34-95,96-95,164v1060c0,68,36,130,95,164l918,530c29,17,62,25,95,25s65-8,95-25l918-530c59-34,95-96,95-164V719
      c0-68-36-130-95-164L1344,25c-29-17-62-25-95-25l0,0H1250z"
                />
                <polygon
                    fill="#213147"
                    points="642,2179 727,1947 897,2088 738,2234"
                />
                <path
                    fill="#FFFFFF"
                    d="M1172,644H939c-17,0-33,11-39,27L401,2039l241,139l550-1507c5-14-5-28-19-28L1172,644z"
                />
                <path
                    fill="#FFFFFF"
                    d="M1580,644h-233c-17,0-33,11-39,27L738,2233l241,139l620-1701c5-14-5-28-19-28V644z"
                />
            </svg>),
            polygon: (<svg width="20px" height="20px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 178 161"
                fill="none"
            >
                <path
                    fill="#FFFFFF"
                    d="M66.8,54.7l-16.7-9.7L0,74.1v58l50.1,29l50.1-29V41.9L128,25.8l27.8,16.1v32.2L128,90.2l-16.7-9.7v25.8  
         l16.7,9.7l50.1-29V29L128,0L77.9,29v90.2l-27.8,16.1l-27.8-16.1V86.9l27.8-16.1l16.7,9.7V54.7z"
                />
            </svg>),
            binance: (<svg width="20px" height="20px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><path fill="#FFFFFF" d="m16.624 13.92 2.717 2.716-7.353 7.353-7.352-7.352 2.717-2.717 4.636 4.66 4.635-4.66zm4.637-4.636L24 12l-2.715 2.716L18.568 12l2.693-2.716zm-9.272 0 2.716 2.692-2.717 2.717L9.272 12l2.716-2.715zm-9.273 0L5.41 12l-2.692 2.692L0 12l2.716-2.716zM11.99.01l7.352 7.33-2.717 2.715-4.636-4.636-4.635 4.66-2.717-2.716L11.989.011z" /></svg>),
        }
        return colors[network] || (<i className="fas fa-gem text-white text-lg"></i>)
    };

    return (
        <>
            {type ? <div className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md">
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[13px] leading-[16px] text-[#6B7280] mt-2">
                            You Funded <span className="font-extrabold">$2300</span> to <em><a href="#" className="text-[#2563EB] underline">StudentNurse25</a></em>
                        </p>
                    </div>
                    <button
                        aria-label="Diamond icon"
                        className={`${getNetworkColor(block)} rounded-r-md rounded-l-md px-3 py-2`}
                    >
                        {getNetworkSvg(block)}
                    </button>
                </div>
                <div
                    className="bg-[#DBEAFE] text-[#2563EB] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#BFDBFE]"
                >
                    <i className="fas fa-info-circle mr-1"></i>
                    Due on <strong>June 30</strong> ({time})
                </div>
                <div className="p-5 pt-4">
                    <p className="text-[13px] leading-[16px] font-normal text-[#6B7280] mb-1">
                        Repayment Progress
                    </p>
                    <p className="text-[36px] font-extrabold text-[#2563EB] leading-[44px]">
                        $2190<span className="text-[#6B7280] font-normal text-[24px]">/$2500</span>
                    </p>
                    <p className="text-[12px] leading-[15px] font-semibold text-[#6B7280] mt-1">
                        <span className="font-extrabold">$310.00</span> Remaining for Complete Payback
                    </p>
                    <div className="w-full h-4 rounded-full bg-[#D9D9D9] mt-3 overflow-hidden">
                        <div className="h-4 rounded-l-full bg-[#15803D]" style={{width: "87.6%"}}></div>
                    </div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full flex items-center justify-center gap-2"
                    type="button"
                >
                    Borrow Insight
                    <i className="fas fa-external-link-alt text-white text-sm"></i>
                </button>
            </div>
            : <div className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md">
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[12px] leading-[15px] text-[#6B7280] mt-1">
                            posted on June 13, 2024
                        </p>
                    </div>
                    <button
                        aria-label="Diamond icon"
                        className={`${getNetworkColor(block)} rounded-r-md rounded-l-md px-3 py-2`}
                    >
                        {getNetworkSvg(block)}
                    </button>
                </div>
                <div className={"text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b " + (time.includes("Day") ? "bg-[#FEE2E2] text-[#EF4444] border-[#FECACA]" : time.includes("Week") ? "bg-[#FEF3C7] text-[#D97706] border-[#FDE68A]" : time.includes("Month") ? "bg-[#D1FAE5] text-[#22C55E] border-[#A7F3D0]" : "border-[#EDE9FE] bg-[#F3E8FF] text-[#A78BFA]")}>
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    {time}
                </div>
                <div className="p-5 pt-4 border-b border-[#E5E7EB] grid grid-cols-3 text-center text-[13px] leading-[16px] font-normal text-[#6B7280]">
                    <div>
                        <p>Asking</p>
                        <p className="mt-1 text-[18px] font-normal text-[#0B1033]">$100</p>
                    </div>
                    <div className="flex items-center justify-center space-x-1 text-[#6B7280]">
                        <span>→</span>
                    </div>
                    <div>
                        <p>Payback</p>
                        <p className="mt-1 text-[16px] font-normal text-[#166534]">$120</p>
                    </div>
                    <div></div>
                    <div>
                        <p>Due on</p>
                        <p className="mt-1 text-[16px] font-normal text-[#B91C1C]">June 30</p>
                    </div>
                    <div></div>
                </div>
                <button
                    className={`${del.includes("Delete") ? "bg-red-600" : del.includes("Repay") ? "bg-blue-600" : "bg-green-600"} text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full`}
                    type="button"
                >
                    {del} Loan
                </button>
            </div>}
        </>
    );
}
